import alertService from '@jetbrains/ring-ui-built/components/alert-service/alert-service'
import Shortcuts from '@jetbrains/ring-ui-built/components/shortcuts/shortcuts'

import {useAppSelector} from '../../../../hooks/react-redux'
import useUID from '../../../../hooks/useUID'
import {getServerInfo} from '../../../../selectors'
import {copyClipboard} from '../../../../utils/clipboard'
import {isPipelinesEnabledInExclusiveMode} from '../../../../utils/featureToggles'
import {useFormattedVersionAndDetails} from '../../Header/HeaderTrayHelp/Footer/Footer.hooks'

const ALERT_TIMEOUT = 10000

export default function Version() {
  const licenseModeName = useAppSelector(state =>
    isPipelinesEnabledInExclusiveMode() ? 'Pipelines' : getServerInfo(state)?.licenseModeName,
  )
  const buildNumber = useAppSelector(state => getServerInfo(state)?.buildNumber)
  const formattedVersionAndDetails = useFormattedVersionAndDetails()
  const fullVersion = `TeamCity ${licenseModeName} ${formattedVersionAndDetails}${buildNumber ? ` (build ${buildNumber})` : ''}`
  const scope = useUID('version-')

  return (
    licenseModeName != null && (
      <Shortcuts
        scope={scope}
        map={{
          v() {
            copyClipboard(fullVersion).then(() =>
              alertService.message(
                `Version has been copied to clipboard by "V" shortcut: ${fullVersion}`,
                ALERT_TIMEOUT,
              ),
            )
          },
        }}
      />
    )
  )
}
